/**
 * The navigation keys this vertical owns.
 *
 * The till and the inventory are NOT here: they are capability-pack
 * vocabulary the profile grants, not keys this module brings.
 */
export const HOSPITALITE_KEYS = [
    "tables",
    "menu",
    "stations",
    "rooms",
    "stays",
    "indicators",
];
//# sourceMappingURL=keys.js.map